var cov_4zsixqp6v = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Upload/styles/index.ts",
      hash = "891578b16285111fee2e9b7ebf6bf5bf96ae3b11",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Upload/styles/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 5,
          column: 27
        },
        end: {
          line: 5,
          column: 59
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();


var uploadLess = {};
import genaration from '../../utils/classname';
export var uploadClass = (cov_4zsixqp6v.s[0]++, genaration(uploadLess, 'upload'));